import { Pipe, PipeTransform } from '@angular/core';
import { App } from '@df/core/app';
import { ProcessorService } from '@df/ng/processor.service';

@Pipe({
    name: 'customerOptionLabel',
    standalone: true
})
export class CustomerOptionLabelPipe implements PipeTransform {
    transform = customerOptionLabelPipe;
}

export function customerOptionLabelPipe(optionValue: number, attributeCode: string): string | number | undefined {
    const app = ProcessorService.injector.get(App);
    const attributeModel = app.resources.customerAttribute.getExisting(attributeCode);
    const option = attributeModel?.data?.options?.find(i => i.value === optionValue);

    return option?.label;
}
